import React, { useEffect, useRef, useState } from "react";
import Activate from "../../../assets/svg/Activate.svg";
import Deactivate from "../../../assets/svg/Deactivate.svg";
import Modal from "../../../components/controls/modal/Modal";
import RolesSetup from "../../../components/controls/roles/Roles";
import Pagination from "../../../components/controls/pagination/Pagination";
import RoleRow from "./rows/rolesRow";
import ResourceRow from "./rows/resourceRow";
import BudgetRow from "./rows/budgetRow";
import MeetingRegisteryRow from "./rows/meetingRegisteryRow";
import AllocatedRsrcRow from "./rows/allocatedRsrcRow";
import ChangeRequestRow from "./rows/changeRequestRow";
import ScopeRow from "./rows/scopeRow";
import TaskRow from "./rows/taskRow";
import ProjectRow from "./rows/projectRow";
import ProgramRow from "./rows/programRow";
import ShiftRow from "./rows/shiftRow";
import CommunicationPlanRow from "./rows/communicationPlanRow";
import ClientRow from "./rows/clientRow";
import Spin from "../../../components/controls/spinner/Spin";
import { ReminderModal as CreateReminder } from "../modal/reminder/Reminder";
import HealthRow from "./rows/healthRow";

import {
  TableBody,
  TableRow,
  Table,
  TableHeader,
} from "@fluentui/react-components";
import {
  ArrowSortIcon,
  DeleteIcon,
  EditIcon,
  PermissionIcon,
  CloudArrowDownSvg,
  DocumentTextSvg,
  RemindIcon,
  MeatBallsMenuIconVertical,
} from "../../../modules/default-svg";
import RiskRow from "./rows/riskRow";
import { useDispatch, useSelector } from "react-redux";
import { getNavExpand } from "../../../store/selectors/general.selector";
import {
  meetingReport,
  meetingReportLoading,
} from "../../../store/selectors/meeting.selector";
import {
  permissionLoader,
  shouldPermissionModalOpen,
} from "../../../store/selectors/user.selector";
import {
  getPermissionsRequest,
  updatePermissionStatus,
} from "../../../store/actions/user.actions";
import PortFolioRow from "./rows/portfolioRow";
import {
  meetingRegistoryRequest,
  clearMeetingReportRequest,
} from "../../../store/actions/meetings.actions";
import { getColumnWidth, setColumnWidth } from "../../../helpers/cookieUtils";
import { useColumnConfig } from "../tables/ColumnConfigProvider";
import api from "../../../store/services/user.service";
import { generalActions } from "../../../store/actions";

export const PopoverMenu = (props) => {
  const {
    type,
    setClosePopover,
    setShowModal,
    setShowDeleteModal,
    setShowPermissionModal,
    setReminderModal,
    setShowConfirmationModal,
    setConfirmationTitle,
    setConfirmationDesc,
    selectedItem,
    setConfirmationBtn,
    handlePreview,
    handleDownload,
  } = props;
  const [permissions, setPermissions] = useState();

  if (type === "Resource") {
    selectedItem.isActive
      ? setConfirmationTitle("Deactivate user")
      : setConfirmationTitle("Activate user");
    selectedItem.isActive
      ? setConfirmationDesc(
          "Are you sure you want to deactivate the selected user? "
        )
      : setConfirmationDesc(
          "Are you sure you want to activate the selected user? "
        );
    selectedItem.isActive
      ? setConfirmationBtn("Deactivate")
      : setConfirmationBtn("Activate");
  }
  const getEditPermission = () => {
    if (permissions) {
      switch (type) {
        case "Role":
          return permissions.includes("Role.Edit") && !selectedItem.isDefault
            ? true
            : false;
        case "Resource":
          return permissions.includes("User.Edit") ? true : false;
        case "Project":
          return permissions.includes("Project.Edit") ? true : false;
        case "Budget":
          return permissions.includes("CostItem.Edit") ? true : false;
        case "Communication Plan":
          return permissions.includes("CommunicationPlan.Edit") ? true : false;
        case "Allocated Resources":
          return true;
        case "Risk":
          return permissions.includes("Risk.Edit") ? true : false;
        case "Change Request":
          return permissions.includes("ChangeRequest.Edit") ? true : false;
        case "Scope":
          return permissions.includes("Scope.Edit") ? true : false;
        case "Milestone":
          return permissions.includes("Scope.Edit") ? true : false;
        case "Tasks":
          return permissions.includes("Task.Edit") ? true : false;
        case "Client":
          return permissions.includes("Client.Edit") ? true : false;
        case "Portfolio":
          return permissions.includes("Portfolio.Edit") ? true : false;
        case "Program":
          return permissions.includes("Program.Edit") ? true : false;
        case "Shift":
          return permissions.includes("Shift.Edit") ? true : false;
        case "TimeOff":
          return permissions.includes("Leave.Edit") ? true : false;
        default:
          return "";
      }
    }
  };

  const getDeletePermission = () => {
    if (permissions) {
      switch (type) {
        case "Role":
          return permissions.includes("Role.Delete") && !selectedItem.isDefault
            ? true
            : false;
        case "Resource":
          return permissions.includes("User.Delete") ? true : false;
        case "Project":
          return (
            permissions.includes("Project.Delete") &&
            !selectedItem.isPendingDelete
          );
        case "Budget":
          return permissions.includes("CostItem.Delete") ? true : false;
        case "Communication Plan":
          return permissions.includes("CommunicationPlan.Delete")
            ? true
            : false;
        case "Allocated Resources":
          return true;
        case "Risk":
          return permissions.includes("Risk.Delete") ? true : false;
        case "Change Request":
          return permissions.includes("ChangeRequest.Delete") ? true : false;
        case "Scope":
          return permissions.includes("Scope.Delete") ? true : false;
        case "Milestone":
          return permissions.includes("Scope.Delete") ? true : false;
        case "Tasks":
          return permissions.includes("Task.Delete") ? true : false;
        case "Client":
          return (
            permissions.includes("Client.Delete") &&
            !selectedItem.isPendingDelete
          );
        case "Portfolio":
          return (
            permissions.includes("Portfolio.Delete") &&
            !selectedItem.isPendingDelete
          );
        case "Program":
          return (
            permissions.includes("Program.Delete") &&
            !selectedItem.isPendingDelete
          );
        case "Shift":
          return permissions.includes("Shift.Delete") && !selectedItem.isDefault
            ? true
            : false;
        default:
          return "";
      }
    }
  };

  const handleStatus = () => {
    setShowConfirmationModal(true);
    setClosePopover(true);
  };

  const handleEdit = () => {
    setShowModal(selectedItem);
    setClosePopover(true);
  };

  const handleReminder = () => {
    setReminderModal(selectedItem);
    setClosePopover(true);
  };

  const handleDelete = () => {
    setShowDeleteModal(selectedItem);
    setClosePopover(true);
  };

  const handlePermissions = () => {
    setShowPermissionModal(selectedItem);
    setClosePopover(true);
  };

  useEffect(() => {
    setPermissions(localStorage.getItem("permissions"));
  }, [localStorage.getItem("permissions")]);

  return (
    <div className="listingPopoverContent">
      {type !== "MeetingRegistry" &&
        type !== "Allocated Resources" &&
        getEditPermission() && (
          <div className="popItem" onClick={() => handleEdit()}>
            <EditIcon />
            <p className="text-sm-400 ms-12">Edit</p>
          </div>
        )}
      <div className="popItem" onClick={() => handleReminder()}>
        <RemindIcon />
        <p className="text-sm-400 ms-12">Remind me</p>
      </div>
      {type === "Resource" && getEditPermission() && (
        <div className="popItem" onClick={() => handleStatus()}>
          <img src={selectedItem.isActive ? Deactivate : Activate} alt="" />
          <p className="text-sm-400 ms-12">{`${
            selectedItem.isActive ? "Deactivate user" : "Activate user"
          }`}</p>
        </div>
      )}
      {type === "Role" && getEditPermission() && (
        <div className="popItem" onClick={() => handlePermissions()}>
          <PermissionIcon />
          <p className="text-sm-400 ms-12">Permissions</p>
        </div>
      )}
      {type !== "MeetingRegistry" &&
        type !== "Allocated Resources" &&
        getDeletePermission() && (
          <div className="popItem" onClick={() => handleDelete()}>
            <DeleteIcon />
            <p className="text-sm-400 ms-12">Delete</p>
          </div>
        )}
      {type === "MeetingRegistry" && (
        <>
          <div
            className="popItem"
            onClick={() => {
              handlePreview(selectedItem);
              setClosePopover(true);
            }}
          >
            <DocumentTextSvg />
            <p className="text-sm-400 ms-12">Preview</p>
          </div>
          <div
            className="popItem"
            onClick={() => {
              handleDownload(selectedItem);
              setClosePopover(true);
            }}
          >
            <CloudArrowDownSvg />
            <p className="text-sm-400 ms-12">Download</p>
          </div>
        </>
      )}
    </div>
  );
};

const TableComponent = (props) => {
  const {
    rows,
    parentType = "",
    type,
    isCreate,
    isEdit,
    setIsCreate,
    setIsEdit,
    handleDelete,
    handleSave,
    handleCancle,
    saveBtnLabel,
    cancelBtnLabel,
    body,
    title,
    setSelectedRow,
    setPageNum,
    setPerPageItems,
    loading,
    handleSavePermissions,
    permissionLoading,
    handlePermissions,
    permissions,
    customTableScrollClass,
    pagination,
    overviewType,
    dashboardFilterSetId,
    dashboardFilterSetName,
    loadingSkeleton = false,
    dashboardFilterId,
    forceShowDeleteModal,
  } = props;
  const getReport = useSelector(meetingReport);
  const getReportLoading = useSelector(meetingReportLoading);
  const [pdfData, setPdfData] = useState("");
  const [meetingActionType, setMeetingActionType] = useState("");
  const [modalTitle, setmodalTitle] = useState(`Create ${type}`);
  const [permissionTitle, setPermissionTitle] = useState("");
  const [showPDFModal, setShowPDFModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [confirmationTitle, setConfirmationTitle] = useState("");
  const [confirmationDesc, setConfirmationDesc] = useState("");
  const [confirmationBtn, setConfirmationBtn] = useState("");
  const [showReminderModal, setShowReminderModal] = useState(false);
  const [showPermissionModal, setShowPermissionModal] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [isStatusUpdate, setIsStatusUpdate] = useState(false);
  const { tableName, columnConfig, updateColumnConfig } = useColumnConfig();
  const [sortingCriteria, setSortingCriteria] = useState({
    column: null,
    order: "asc",
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setPerPage] = useState(10);
  const [closePopover, setClosePopover] = useState(false);

  const navExpand = useSelector(getNavExpand);
  const getPermissionLoading = useSelector(permissionLoader);
  const dispatch = useDispatch();

  const isPermissionModalOpen = useSelector(shouldPermissionModalOpen);

  const [width, setWidth] = useState([]);

  const [draggedColumn, setDraggedColumn] = useState(null);
  const [targetColumn, setTargetColumn] = useState(null);
  const [isHoverOverColumn, setIsHoverOverColumn] = useState({
    columnId: null,
    status: false,
  });

  const updateColumnLabel = (columnId, newLabel) => {
    const updatedColumns = columnConfig.map((col) =>
      col.columnId === columnId ? { ...col, customName: newLabel.trim() } : col
    );

    if (updatedColumns.length) {
      const updatedColumnsDB = updatedColumns.map((col) => ({
        name: col.label,
        customName: col.customName ?? "",
        order: col.order,
        isVisible: col.isVisible,
      }));

      const payload = {
        Name: tableName,
        Columns: updatedColumnsDB,
      };

      api
        .putUserLayoutRequest(payload)
        .then((res) => {
          dispatch(
            generalActions.showToast({
              title: "Column name updated successfully",
              type: "success",
            })
          );
          updateColumnConfig(updatedColumns);
        })
        .catch((err) => {
          dispatch(
            generalActions.showToast({
              title: "Error updating column name",
              type: "error",
            })
          );
        });
    }
  };
  const totalItems = rows.length;
  let totalPages = Math.ceil(totalItems / itemsPerPage);
  // const startIndex = (currentPage - 1) * itemsPerPage;
  // const endIndex = Math.min(startIndex + itemsPerPage, totalItems);
  // let currentPageData = rows?.slice(startIndex, endIndex);

  useEffect(() => {
    const totalItems = rows.length;
    totalPages = Math.ceil(totalItems / itemsPerPage);

    // const startIndex = (currentPage - 1) * itemsPerPage;
    // const endIndex = Math.min(startIndex + itemsPerPage, totalItems);
    // currentPageData = rows?.slice(startIndex, endIndex);
  }, [itemsPerPage]);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    setPageNum(pageNumber);
  };

  const pageNumbers = Array.from(
    { length: totalPages },
    (_, index) => index + 1
  );

  const handeShowActionModal = (item) => {
    setClosePopover(false);

    setSelectedItem(item);
  };

  const handleEdit = (item) => {
    setClosePopover(false); //

    setShowModal(true);
    setSelectedRow(item);
    setSelectedItem(item);
    setmodalTitle(`Edit ${type === "Tasks" ? title : type}`);
    setIsEdit(true);
  };

  const deleteHandler = (item) => {
    setClosePopover(false); //

    setSelectedItem(item);
    localStorage.setItem("selectedRow", JSON.stringify(item));
    setShowDeleteModal(true);
  };

  const handeCancel = () => {
    setShowModal(false);
    setIsCreate(false);
    setShowConfirmationModal(false);
    setShowDeleteModal(false);
    setIsStatusUpdate(false);
    handleCancle();

    setClosePopover(false);

    localStorage.removeItem("selectedRow");
  };

  const handleShowPermissions = (item) => {
    setClosePopover(false);
    setShowPermissionModal(true);
    setPermissionTitle(item?.name || "");
    dispatch(getPermissionsRequest(item.id));
    localStorage.setItem("selectedRow", JSON.stringify(item));
  };

  const handleShowReminder = (item) => {
    setClosePopover(false);

    setShowReminderModal(true);
    localStorage.setItem("selectedRow", JSON.stringify(item));
  };

  const handleConfirm = () => {
    setIsStatusUpdate(true);
  };

  const handlePreview = (item) => {
    dispatch(clearMeetingReportRequest());
    dispatch(meetingRegistoryRequest({ id: item?.id }));
    setShowPDFModal(true);
  };

  const meetingRegistoryModalCloseHandler = () => {
    dispatch(clearMeetingReportRequest());
    setShowPDFModal(false);
    setPdfData("");
  };

  useEffect(() => {
    if (getReport) {
      const pdfBlob = new Blob([getReport], { type: "application/pdf" });
      const blobUrl = URL.createObjectURL(pdfBlob);
      if (meetingActionType === "Download") {
        // Create a link element
        const link = document.createElement("a");

        // Set the href attribute to the blob URL
        link.href = blobUrl;

        // Set the download attribute with the desired file name
        link.download = "meeting-registery.pdf";

        // Append the link to the document body
        document.body.appendChild(link);

        // Trigger a click event on the link
        link.click();

        // Remove the link from the document body
        document.body.removeChild(link);
        return;
      }
      setPdfData(blobUrl);
    }
  }, [getReport, getReportLoading]);

  const handleDownload = (item) => {
    setMeetingActionType("Download");
    dispatch(meetingRegistoryRequest({ id: item?.id }));
  };

  const tableRef = useRef();

  useEffect(() => {
    if (isCreate) {
      setShowModal(true);
      setmodalTitle(
        type === "Resource"
          ? `Add ${type}`
          : `Create  ${type === "Tasks" ? title : type}`
      );
      setSelectedRow({});
    } else {
      setShowModal(false);
    }
  }, [isCreate]);

  useEffect(() => {
    setShowModal(isEdit);
  }, [isEdit]);

  useEffect(() => {
    if (!loading) {
      setShowModal(false);
      if (type === "Role" && isCreate) {
        const item = JSON.parse(localStorage.getItem("selectedRow"));
        handleShowPermissions(item);
      }
      setShowDeleteModal(false);
      setIsCreate(false);
      setShowConfirmationModal(false);
    }
  }, [loading]);

  useEffect(() => {
    setPerPageItems && setPerPageItems(itemsPerPage);
  }, [itemsPerPage]);

  useEffect(() => {
    if (!permissionLoading) {
      setShowPermissionModal(false);
    }
  }, [permissionLoading]);

  useEffect(() => {
    if (forceShowDeleteModal != null) {
      setShowDeleteModal(forceShowDeleteModal);
    }
  }, [forceShowDeleteModal]);

  const getTableBody = () => {
    const menu = (
      <PopoverMenu
        type={type}
        closePopover={closePopover}
        setClosePopover={setClosePopover}
        selectedItem={selectedItem}
        setShowModal={(item) => handleEdit(item)}
        handlePreview={(item) => handlePreview(item)}
        handleDownload={(item) => handleDownload(item)}
        setShowDeleteModal={(item) => deleteHandler(item)}
        setReminderModal={(item) => handleShowReminder(item)}
        setShowPermissionModal={(item) => handleShowPermissions(item)}
        setShowConfirmationModal={setShowConfirmationModal}
        setConfirmationTitle={setConfirmationTitle}
        setConfirmationDesc={setConfirmationDesc}
        setConfirmationBtn={setConfirmationBtn}
      />
    );
    const path = window.location.pathname;
    const id = path.split("/")[3];
    const clientId = path.split("/")[3];
    const programId = path.split("/")[3];
    const portfolioId = path.split("/")[3];
    switch (type) {
      case "Role":
        return (
          <RoleRow
            menu={menu}
            sortingCriteria={sortingCriteria}
            data={rows}
            handleModal={(item) => handeShowActionModal(item)}
            columnConfig={columnConfig}
          />
        );
      case "Resource":
        return (
          <ResourceRow
            menu={menu}
            item={selectedItem}
            sortingCriteria={sortingCriteria}
            data={rows}
            handleModal={(item) => handeShowActionModal(item)}
            updateStatus={isStatusUpdate}
            setUpdateStatus={setIsStatusUpdate}
            columnConfig={columnConfig}
          />
        );
      case "Risk":
        return (
          <RiskRow
            menu={menu}
            item={selectedItem}
            sortingCriteria={sortingCriteria}
            data={rows}
            handleModal={(item) => handeShowActionModal(item)}
            parentType={parentType}
            projectId={id}
            programId={programId}
            updateStatus={isStatusUpdate}
            portfolioId={portfolioId}
            columnConfig={columnConfig}
            overviewType={overviewType}
            dashboardFilterSetProjectId={dashboardFilterSetId}
            dashboardFilterSetProjectName={dashboardFilterSetName}
            loadingSkeleton={loadingSkeleton}
          />
        );
      case "Scope":
        return (
          <ScopeRow
            menu={menu}
            item={selectedItem}
            sortingCriteria={sortingCriteria}
            data={rows}
            handleModal={(item) => handeShowActionModal(item)}
            updateStatus={isStatusUpdate}
            parentType={parentType}
            projectId={id}
            programId={programId}
            portfolioId={portfolioId}
            columnConfig={columnConfig}
          />
        );
      case "Milestone":
        return (
          <ScopeRow
            menu={menu}
            item={selectedItem}
            sortingCriteria={sortingCriteria}
            data={rows}
            handleModal={(item) => handeShowActionModal(item)}
            updateStatus={isStatusUpdate}
            parentType={parentType}
            projectId={id}
            programId={programId}
            portfolioId={portfolioId}
            columnConfig={columnConfig}
            isMilestone={true}
          />
        );
      case "Tasks":
        return (
          <TaskRow
            menu={menu}
            item={selectedItem}
            sortingCriteria={sortingCriteria}
            data={rows}
            handleModal={(item) => handeShowActionModal(item)}
            scopeId={id}
          />
        );
      case "Allocated Resources":
        return (
          <AllocatedRsrcRow
            menu={menu}
            item={selectedItem}
            sortingCriteria={sortingCriteria}
            data={rows}
            handleModal={(item) => handeShowActionModal(item)}
            parentType={parentType}
            projectId={id}
            programId={programId}
            clientId={clientId}
            portfolioId={portfolioId}
          />
        );
      case "Communication Plan":
        return (
          <CommunicationPlanRow
            menu={menu}
            item={selectedItem}
            sortingCriteria={sortingCriteria}
            data={rows}
            handleModal={(item) => handeShowActionModal(item)}
            parentType={parentType}
            projectId={id}
            programId={programId}
            clientId={clientId}
            portfolioId={portfolioId}
            columnConfig={columnConfig}
          />
        );
      case "Budget":
        return (
          <BudgetRow
            menu={menu}
            sortingCriteria={sortingCriteria}
            data={rows}
            handleModal={(item) => handeShowActionModal(item)}
            parentType={parentType}
            programId={programId}
            portfolioId={portfolioId}
            projectId={id}
            columnConfig={columnConfig}
          />
        );
      case "Change Request":
        return (
          <ChangeRequestRow
            menu={menu}
            sortingCriteria={sortingCriteria}
            data={rows}
            handleModal={(item) => handeShowActionModal(item)}
            parentType={parentType}
            projectId={id}
            programId={programId}
            portfolioId={portfolioId}
            columnConfig={columnConfig}
          />
        );
      case "MeetingRegistry":
        return (
          <MeetingRegisteryRow
            menu={menu}
            data={rows}
            sortingCriteria={sortingCriteria}
            handleModal={(item) => handeShowActionModal(item)}
          />
        );
      case "Project":
        return (
          <ProjectRow
            menu={menu}
            item={selectedItem}
            sortingCriteria={sortingCriteria}
            data={rows}
            handleModal={(item) => handeShowActionModal(item)}
            updateStatus={isStatusUpdate}
            parentType={parentType}
            projectId={id}
            clientId={clientId}
            portfolioId={portfolioId}
            columnConfig={columnConfig}
          />
        );
      case "Client":
        return (
          <ClientRow
            menu={menu}
            item={selectedItem}
            sortingCriteria={sortingCriteria}
            data={rows}
            handleModal={(item) => handeShowActionModal(item)}
            columnConfig={columnConfig}
          />
        );
      case "Portfolio":
        return (
          <PortFolioRow
            menu={menu}
            item={selectedItem}
            sortingCriteria={sortingCriteria}
            data={rows}
            handleModal={(item) => handeShowActionModal(item)}
            parentType={parentType}
            clientId={clientId}
            columnConfig={columnConfig}
            overviewType={overviewType}
            dashboardFilterSetId={dashboardFilterSetId}
            dashboardFilterSetName={dashboardFilterSetName}
            loadingSkeleton={loadingSkeleton}
            dashboardFilterId={dashboardFilterId}
          />
        );
      case "Program":
        return (
          <ProgramRow
            menu={menu}
            item={selectedItem}
            sortingCriteria={sortingCriteria}
            data={rows}
            handleModal={(item) => handeShowActionModal(item)}
            parentType={parentType}
            clientId={clientId}
            portfolioId={portfolioId}
            columnConfig={columnConfig}
          />
        );
      case "Shift":
        return (
          <ShiftRow
            menu={menu}
            item={selectedItem}
            sortingCriteria={sortingCriteria}
            data={rows}
            handleModal={(item) => handeShowActionModal(item)}
            parentType={parentType}
            columnConfig={columnConfig}
          />
        );
      case "HealthStatus":
        return (
          <HealthRow
            menu={menu}
            sortingCriteria={sortingCriteria}
            data={rows}
            handleModal={(item) => handeShowActionModal(item)}
            columnConfig={columnConfig}
            dashboardFilterSetId={dashboardFilterSetId}
            dashboardFilterSetName={dashboardFilterSetName}
            loadingSkeleton={loadingSkeleton}
          />
        );
      default:
        <></>;
    }
  };

  const handleSort = (columnKey) => {
    if (sortingCriteria.column === columnKey) {
      setSortingCriteria({
        ...sortingCriteria,
        order: sortingCriteria.order === "asc" ? "desc" : "asc",
      });
    } else {
      setSortingCriteria({ column: columnKey, order: "asc" });
    }
  };

  const getReminderType = (type) => {
    switch (type) {
      case "Resource":
        return "User";
      case "Change Request":
        return "ChangeRequest";
      case "Budget":
        return "CostItem";
      case "Scope Item":
        return "Scope";
      case "Tasks":
        return "Task";
      case "Allocated Resources":
        return "User";
      case "Communication Plan":
        return "CommunicationPlan";
      default:
        return type;
    }
  };

  useEffect(() => {
    const fetchColumns = (length) => {
      const arr = [];
      for (let i = 0; i < length; i++) {
        arr.push(tableRef.current.clientWidth / length);
      }
      return arr;
    };
    setWidth(
      fetchColumns(
        columnConfig.length
          ? columnConfig?.filter((col) => col.isVisible).length
          : 1
      )
    );
  }, [columnConfig]);

  const ResizableTableHeader = ({
    column,
    handleSort,
    index,
    isLastColumn,
    sortingCriteria,
    updateColumnLabel,
    isFirstColumn,
  }) => {
    const savedWidth = getColumnWidth(tableName, column.columnId);
    const MIN_COLUMN_WIDTH = 100;
    const thRef = useRef(null);
    const [tempWidth, setTempWidth] = useState(
      savedWidth === null
        ? Math.max(width[index], MIN_COLUMN_WIDTH)
        : Math.max(savedWidth, MIN_COLUMN_WIDTH)
    );
    const currentWidthRef = useRef(tempWidth);
    const [isEditing, setIsEditing] = useState(false);
    const [label, setLabel] = useState(column.customName || column.label);
    const singleClickTimer = useRef(null);
    const [isResizing, setIsResizing] = useState(false);

    // Ensure draggable is set after mount
    useEffect(() => {
      if (thRef.current && !isEditing && !isResizing) {
        thRef.current.setAttribute("draggable", "true");
      }
    }, [isEditing, isResizing]);

    useEffect(() => {
      const initialWidth = savedWidth === null ? width[index] : savedWidth;
      const constrainedWidth = Math.max(initialWidth, MIN_COLUMN_WIDTH);
      setTempWidth(constrainedWidth);
      currentWidthRef.current = constrainedWidth;
    }, [width, index, savedWidth]);

    const handleMouseDown = (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (isLastColumn || isEditing) return;

      setIsResizing(true);
      const startX = e.clientX;
      let startWidth = width[index];

      const handleMouseMove = (moveEvent) => {
        const newWidth = startWidth + (moveEvent.clientX - startX);
        const constrainedWidth = Math.max(newWidth, MIN_COLUMN_WIDTH);
        setTempWidth(constrainedWidth);
        currentWidthRef.current = constrainedWidth;
      };

      const handleMouseUp = () => {
        setIsResizing(false);
        const finalWidth = currentWidthRef.current;
        const newWidths = [...width];
        newWidths[index] = finalWidth;
        setWidth(newWidths);
        setColumnWidth(tableName, column.columnId, finalWidth);
        document.removeEventListener("mousemove", handleMouseMove);
        document.removeEventListener("mouseup", handleMouseUp);
      };

      document.addEventListener("mousemove", handleMouseMove);
      document.addEventListener("mouseup", handleMouseUp);
    };

    const handleLabelChange = (e) => {
      setLabel(e.target.value);
    };

    const handleLabelSave = () => {
      setIsEditing(false);
      updateColumnLabel(column.columnId, label);
    };

    const handleSingleClick = (e) => {
      if (!column.isSortable || isEditing || isResizing) return;
      e.stopPropagation();
      clearTimeout(singleClickTimer.current);
      singleClickTimer.current = setTimeout(() => {
        handleSort(column.columnId);
      }, 200);
    };

    const handleDoubleClick = (e) => {
      if (isResizing) return;
      e.stopPropagation();
      clearTimeout(singleClickTimer.current);
      setIsEditing(true);
    };

    const onHandleDragStart = (e) => {
      e.stopPropagation();
      e.dataTransfer.effectAllowed = "move";
      e.dataTransfer.setData("text/plain", column.columnId);
      setDraggedColumn(column.columnId);
    };

    const handleDragOver = (e, columnId) => {
      e.preventDefault();
      if (draggedColumn === columnId) return;
      setTargetColumn(columnId);
    };

    const handleDragEnd = () => {
      if (
        draggedColumn &&
        targetColumn &&
        draggedColumn !== targetColumn &&
        columnConfig?.length
      ) {
        const updatedConfig = [...columnConfig];
        const draggedIndex = updatedConfig.findIndex(
          (col) => col.columnId === draggedColumn
        );
        const targetIndex = updatedConfig.findIndex(
          (col) => col.columnId === targetColumn
        );

        if (draggedIndex === -1 || targetIndex === -1 || isFirstColumn) {
          setDraggedColumn(null);
          setTargetColumn(null);
          return;
        }

        const [draggedItem] = updatedConfig.splice(draggedIndex, 1);
        updatedConfig.splice(targetIndex, 0, draggedItem);

        updatedConfig.forEach((col, index) => {
          if (col.order !== undefined) {
            col.order = index;
          }
        });

        const updatedColumnsDB = updatedConfig.map((col) => ({
          name: col.label,
          customName: col.customName ?? "",
          order: col.order,
          isVisible: col.isVisible,
        }));

        const payload = {
          Name: tableName,
          Columns: updatedColumnsDB,
        };
        api
          .putUserLayoutRequest(payload)
          .then((res) => {
            dispatch(
              generalActions.showToast({
                title: "Column name updated successfully",
                type: "success",
              })
            );
            updateColumnConfig(updatedConfig);
          })
          .catch((err) => {
            dispatch(
              generalActions.showToast({
                title: "Error updating column name",
                type: "error",
              })
            );
          });
      }
      setDraggedColumn(null);
      setTargetColumn(null);
    };

    const handleDrop = (e, columnId) => {
      e.preventDefault();
      handleDragEnd();
    };

    const isActive = sortingCriteria.column === column.columnId;

    return (
      <th
        className="customHeaderCell"
        ref={thRef}
        style={{
          width: isLastColumn ? "100%" : `${tempWidth}px`,
          minWidth: isLastColumn ? "auto" : `${tempWidth}px`,
          position: "relative",
        }}
        draggable={!isEditing && !isResizing && !isFirstColumn}
        onDragStart={(e) => !isFirstColumn && onHandleDragStart(e)}
        onDragOver={(e) => {
          e.preventDefault();
          if (!isResizing && !isFirstColumn) handleDragOver(e, column.columnId);
        }}
        onDragEnd={(e) => !isFirstColumn && handleDragEnd(e)}
        onDrop={(e) => !isFirstColumn && handleDrop(e, column.columnId)}
        onMouseEnter={() =>
          !isFirstColumn &&
          !isEditing &&
          !isResizing &&
          !draggedColumn &&
          setIsHoverOverColumn({
            columnId: column.columnId,
            status: true,
          })
        }
        onMouseLeave={() =>
          !isFirstColumn &&
          !isEditing &&
          !isResizing &&
          !draggedColumn &&
          setIsHoverOverColumn({
            columnId: null,
            status: false,
          })
        }
      >
        <div
          className={`header-content flex hover:bg-[#ece8fd75] cursor-pointer ${
            isEditing || draggedColumn === column.columnId
              ? "bg-[#ece8fd75]"
              : ""
          }`}
          onClick={handleSingleClick}
          onDoubleClick={handleDoubleClick}
        >
          {isEditing ? (
            <input
              value={label}
              onChange={handleLabelChange}
              onBlur={handleLabelSave}
              onKeyPress={(e) => e.key === "Enter" && handleLabelSave()}
              autoFocus
              style={{
                width: isLastColumn ? "100%" : `${tempWidth}px`,
                minWidth: isLastColumn ? "auto" : `${tempWidth}px`,
              }}
            />
          ) : (
            <div
              className={`flex w-full ${
                column.isSortable ? "cursor-pointer" : ""
              }`}
            >
              <span>{label}</span>
              {column.isSortable && (
                <span style={{ paddingTop: 3, marginLeft: 8 }}>
                  <ArrowSortIcon
                    isActive={isActive}
                    sortDirection={isActive ? sortingCriteria.order : null}
                  />
                </span>
              )}
              {type !== "Role" &&
              type !== "Shift" &&
              !isFirstColumn &&
              isHoverOverColumn.columnId === column.columnId ? (
                <span
                  className="absolute right-2"
                  style={{ marginLeft: 8 }}
                  onClick={(e) => {
                    e.stopPropagation();
                    setDraggedColumn(column.columnId);
                  }}
                >
                  <MeatBallsMenuIconVertical
                    isActive={draggedColumn === column.columnId}
                  />
                </span>
              ) : draggedColumn === column.columnId ? (
                <span className="absolute right-2" style={{ marginLeft: 8 }}>
                  <MeatBallsMenuIconVertical isActive={true} />
                </span>
              ) : null}
            </div>
          )}
        </div>
        {!isLastColumn && (
          <div
            className="resize-handle d-flex justify-content-center align-items-center"
            onMouseDown={handleMouseDown}
          >
            <div />
          </div>
        )}
      </th>
    );
  };

  const sortedColumnConfig = [...columnConfig].sort(
    (a, b) => a.order - b.order
  );

  return (
    <div
      className={`customTableContainer ${customTableScrollClass} ${
        navExpand ? "ExpandedNavTable" : "collapseNavTable"
      }`}
      ref={tableRef}
    >
      <Table arial-label="Default table" className="customTableWrapper">
        <TableHeader>
          <TableRow>
            {sortedColumnConfig
              .filter((column) => column.isVisible)
              .map((column, index) => (
                <ResizableTableHeader
                  key={column.columnId}
                  column={column}
                  isLastColumn={
                    index ===
                    columnConfig.filter((column) => column.isVisible).length - 1
                  }
                  isFirstColumn={index === 0}
                  handleSort={handleSort}
                  index={index}
                  sortingCriteria={sortingCriteria}
                  updateColumnLabel={updateColumnLabel}
                />
              ))}
          </TableRow>
        </TableHeader>
        <TableBody>{getTableBody()}</TableBody>
      </Table>
      {showReminderModal && (
        <CreateReminder
          setIsModalOpen={setShowReminderModal}
          type={getReminderType(type)}
          selectedTag={selectedItem}
        />
      )}
      {showModal &&
        (type === "Role" || type === "Shift" ? (
          <Modal
            title={modalTitle}
            handleCancel={() => handeCancel()}
            handleSave={() => handleSave()}
            saveBtnLabel={saveBtnLabel}
            cancelBtnLabel={cancelBtnLabel}
            isLoading={loading}
            body={body}
            size="small"
          />
        ) : (
          <Modal
            title={modalTitle}
            handleCancel={() => handeCancel()}
            handleSave={() => handleSave()}
            saveBtnLabel={saveBtnLabel}
            cancelBtnLabel={cancelBtnLabel}
            isLoading={loading}
            body={body}
            size="large"
          />
        ))}
      {isPermissionModalOpen &&
        showPermissionModal &&
        !getPermissionLoading && (
          <Modal
            title={`${permissionTitle} - Permissions`}
            handleCancel={() => {
              setShowPermissionModal(false);
              dispatch(updatePermissionStatus());
            }}
            handleSave={handleSavePermissions}
            saveBtnLabel={saveBtnLabel}
            cancelBtnLabel={cancelBtnLabel}
            isLoading={permissionLoading}
            size="large"
            body={
              <RolesSetup
                handlePermissions={handlePermissions}
                permissions={permissions}
              />
            }
          />
        )}
      {showDeleteModal && (
        <Modal
          title={`Delete ${type}`}
          body={
            <p className="text-sm-400 subHeading-color">{`Are you sure you want to delete the selected ${type.toLowerCase()}?`}</p>
          }
          handleCancel={() => handeCancel()}
          handleSave={() => handleDelete()}
          saveBtnLabel={`Delete`}
          cancelBtnLabel={cancelBtnLabel}
          isLoading={loading}
        />
      )}
      {showConfirmationModal && (
        <Modal
          title={confirmationTitle}
          body={confirmationDesc}
          handleCancel={() => handeCancel()}
          handleSave={() => handleConfirm()}
          saveBtnLabel={saveBtnLabel}
          cancelBtnLabel={cancelBtnLabel}
          savebtnLabel={confirmationBtn}
          isLoading={false}
        />
      )}
      {showPDFModal && (
        <Modal
          title={`Meeting Minutes Report`}
          handleCancel={meetingRegistoryModalCloseHandler}
          body={
            pdfData ? (
              <iframe
                title="PDF Viewer"
                src={pdfData}
                width="100%"
                height="100%"
              ></iframe>
            ) : (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                  width: "100%",
                }}
              >
                <Spin />
              </div>
            )
          }
          type={true}
          size=""
        />
      )}
      <Pagination
        pagination={pagination}
        itemsPerPage={itemsPerPage}
        setItemsPerPage={setPerPage}
        currentPage={currentPage}
        pageNumbers={pageNumbers}
        totalPages={totalPages}
        handlePageChange={handlePageChange}
      />
    </div>
  );
};

export default TableComponent;
